import {useBlockProps} from "@wordpress/block-editor";
import "./editor.scss";
import {FocusableIframe} from '@wordpress/components';

export default function Edit({attributes}) {

    const blockProps = useBlockProps();

    return (
        <div {...blockProps}>
            {attributes.filterUrl ? (
                    <FocusableIframe
                        src={`https://www.werstreamt.es/widgets/filter/embed/?filterUrl=${attributes.filterUrl}&hideEntryWithoutProvider=${attributes.hideEntryWithoutProvider}&limit=${attributes.limit}&providers=${attributes.selectedProviders}&showNumbers=${attributes.showNumbers}&style=${attributes.style}`}></FocusableIframe>
                )
                : "Hier klicken um das WerStreamt.es Widget zu konfigurieren."
            }
        </div>
    );

}
